import React, { useCallback } from 'react';

import jira from 'src/lib/api/jira';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

const ProjectsSelect = ({ ...props }) => {
  const loadOptions = useCallback(filter => jira
    .getCashedProjects(filter)
    .then(
      (projects) => projects.map(s => {
        const [baseUrl, rest] = (s.self || '').split('/rest/api');
        const html_url = rest ? `${baseUrl}/projects/${s.key}` : baseUrl;

        return (
          {
            key: s.key,
            id: s.id,
            label: s.name,
            html_url,
            icon: Object.values(s.avatarUrls || {})[0],
          });
      })
    ), []);

  return (
    <GenericAsyncSelect
      loadOptions={loadOptions}
      placeholder="Select Jira Project..."
      hasIcons
      {...props}
    />
  );
};

export default ProjectsSelect;
